<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title> Filter {{ tab.title }} </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              v-model="filter.search"
              outlined
              label="Search"
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="filter.published"
              :items="yes_no_items"
              outlined
              label="Published?"
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="filter.categoryId"
              :items="categories"
              item-text="name"
              item-value="id"
              label="Category"
              outlined
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="filter.industryId"
              :items="industries"
              item-text="name"
              item-value="id"
              label="Industry"
              outlined
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="filter.topicId"
              :items="topics"
              item-text="name"
              item-value="id"
              label="Topic"
              outlined
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="filter.designGroupId"
              :items="design_groups"
              item-text="name"
              item-value="id"
              label="Design Group"
              outlined
              clearable
            />
          </v-col>
          <v-col
            v-if="id == 'templates'"
            cols="12"
          >
            <v-select
              v-model="filter.mfgTypeIds"
              multiple
              :items="mfg_types"
              item-value="id"
              item-text="name"
              outlined
              label="Mfg Types"
              clearable
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Done
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'TemplateFilter',
  data() {
    return {
      valid: false,
      drawer: false,
      saving: false,
      filter: { mfgTypeIds: [] },
      yes_no_items: [
        { text: 'Yes', value: true },
        { text: 'No', value: false }
      ]
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
    tab() {
      return this.$enums.CATALOG_TABS.find((x) => x.id === this.id) || {};
    },
    ...mapGetters({
      categories: 'lookup/categories',
      industries: 'lookup/industries',
      topics: 'lookup/topics',
      design_groups: 'lookup/design_groups',
      mfg_types: 'lookup/mfg_types'
    })
  },
  mounted() {},
  methods: {
    show() {
      this.drawer = true;
      this.filter = Object.assign({}, cloneDeep(this.$store.getters['catalog/filter']));
    },
    save() {
      this.saving = true;
      const filter = cloneDeep(this.filter);
      filter.page = 1;
      Promise.all([
        this.$store.dispatch('catalog/filter', filter),
        this.$store.dispatch(`${this.tab.store}/${this.tab.loadAction || 'load'}`, this.filter),
        this.$store.dispatch('catalog/setSelected', [])
      ])
        .then(() => {
          this.drawer = false;
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
